import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { ReactElement, ReactNode, memo } from 'react';

import { LOCK_COLOR, MOVEABLE_LOCK_CLASS } from '../../../../constants/bounding-box';
import { useFocus } from '../Focus';
import { SCROLL_CONTAINER_ID } from './PageArea.config';

export const StyledScrollContainerBox = styled(Box)`
  overflow: auto;
  height: 100%;
  position: relative;
  background-color: var(--vg-colors-gray-100);
  scrollbar-gutter: stable;

  .${MOVEABLE_LOCK_CLASS} .moveable-line.moveable-direction {
    height: 2px;
    background: ${LOCK_COLOR} !important;
  }
`;

export const PageScrollContainer = memo(({ children }: { children: ReactNode }): ReactElement => {
  const { pageScrollContainerRef } = useFocus();

  return (
    <StyledScrollContainerBox ref={pageScrollContainerRef} id={SCROLL_CONTAINER_ID} data-testid={SCROLL_CONTAINER_ID}>
      {children}
    </StyledScrollContainerBox>
  );
});
PageScrollContainer.displayName = 'PageScrollContainer';
